import { Component, Inject, OnInit } from '@angular/core';
import { SOPO_DIALOG_DATA, SopoDialogRef } from '../../interfaces/dialog';
import { SopoDialogSettings } from "../../interfaces/dialog";

export class SopoDoubleInputSettings extends SopoDialogSettings {
    data: SopoDoubleInputData;
}
export interface SopoDoubleInputData {
    header?: string;
    body?: string;
    note?: string
    okText?: string;
    cancelText?: string;
    firstPlaceholder?: string;
    secondPlaceholder?: string;
    deepLinkClubId?: string;
}

@Component({
    selector: 'app-sopo-double-input',
    templateUrl: './sopo-double-input.component.html',
    styleUrls: ['./sopo-double-input.component.scss'],
    standalone: false
})
export class SopoDoubleInputComponent implements OnInit {
    header: string = '';
    body: string = '';
    note: string = '';
    firstPlaceholder: string = '';
    secondPlaceholder: string = '';
    okText: string = '';
    cancelText: string = '';

    firstInput: string = '';
    secondInput: string = '';

    constructor(
        @Inject(SOPO_DIALOG_DATA) data: SopoDoubleInputData,
        private sopoDialogRef: SopoDialogRef,
    ) { 
        if (data.header) this.header = data.header;
        if (data.body) this.body = data.body;
        if (data.note) this.note = data.note;
        if (data.firstPlaceholder) this.firstPlaceholder = data.firstPlaceholder;
        if (data.secondPlaceholder) this.secondPlaceholder = data.secondPlaceholder;
        if (data.okText) this.okText = data.okText;
        if (data.cancelText) this.cancelText = data.cancelText;
        if (data.deepLinkClubId) this.firstInput = data.deepLinkClubId;
    }

    ngOnInit() {}

    close(close: boolean = false) {
        if (close) {
            this.sopoDialogRef.close(null);
        } else {
            const data = {
                firstInput: this.firstInput,
                secondInput: this.secondInput
            }
            this.sopoDialogRef.close(data);
        }
    }
}
